import React, { useState } from 'react';
import SelectCiudad from './SelectCiudad';
import './ClienteForm.css';

const ClienteForm = ({ clienteInicial = {}, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    nombre: clienteInicial.nombre || '',
    documento: clienteInicial.documento || '',
    tipoDocumento: clienteInicial.tipoDocumento || 'cc',
    email: clienteInicial.email || '',
    telefono: clienteInicial.telefono || '',
    direccion: clienteInicial.direccion || '',
    ciudad: clienteInicial.ciudad || '',
    observaciones: clienteInicial.observaciones || ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleCiudadChange = (e) => {
    setFormData(prev => ({ ...prev, ciudad: e.target.value }));
    if (errors.ciudad) {
      setErrors(prev => ({ ...prev, ciudad: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nombre.trim()) newErrors.nombre = 'El nombre es requerido';
    if (!formData.documento.trim()) newErrors.documento = 'El documento es requerido';
    if (!formData.email.trim()) {
      newErrors.email = 'El email es requerido';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email inválido';
    }
    if (!formData.telefono.trim()) newErrors.telefono = 'El teléfono es requerido';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length === 0) {
      onSubmit(formData);
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="cliente-form">
      <div className="form-field">
        <label>Número de Documento <span className="required">*</span></label>
        <input
          type="text"
          name="documento"
          value={formData.documento}
          onChange={handleChange}
          className={errors.documento ? 'error' : ''}
          placeholder="Ej: 123456789"
        />
        {errors.documento && <span className="error-message">{errors.documento}</span>}
      </div>

      <div className="form-field">
        <label>Nombre Completo <span className="required">*</span></label>
        <input
          type="text"
          name="nombre"
          value={formData.nombre}
          onChange={handleChange}
          className={errors.nombre ? 'error' : ''}
          placeholder="Nombres y apellidos completos"
        />
        {errors.nombre && <span className="error-message">{errors.nombre}</span>}
      </div>

      <div className="form-row">
        <div className="form-field half">
          <label>Correo Electrónico <span className="required">*</span></label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={errors.email ? 'error' : ''}
            placeholder="cliente@ejemplo.com"
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>

        <div className="form-field half">
          <label>Teléfono <span className="required">*</span></label>
          <input
            type="tel"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            className={errors.telefono ? 'error' : ''}
            placeholder="Ej: 3001234567"
          />
          {errors.telefono && <span className="error-message">{errors.telefono}</span>}
        </div>
      </div>

      <div className="form-row">
        <div className="form-field half">
          <label>Dirección</label>
          <input
            type="text"
            name="direccion"
            value={formData.direccion}
            onChange={handleChange}
            placeholder="Calle, número, barrio"
          />
        </div>

        <div className="form-field half">
          <SelectCiudad 
            value={formData.ciudad}
            onCiudadChange={handleCiudadChange}
          />
        </div>
      </div>

      <div className="form-field">
        <label>Observaciones</label>
        <textarea
          name="observaciones"
          rows="3"
          value={formData.observaciones}
          onChange={handleChange}
          placeholder="Información adicional sobre el cliente..."
        />
      </div>

      <div className="form-actions">
        <button type="button" className="btn-cancelar" onClick={onCancel}>
          Cancelar
        </button>
        <button type="submit" className="btn-guardar">
          {clienteInicial.id ? 'Actualizar Cliente' : 'Guardar Cliente'}
        </button>
      </div>
    </form>
  );
};

export default ClienteForm;